import React from "react";
import styled, { keyframes } from "styled-components";

/**
 * AI Glow Effect Component
 * Animated gradient border effect for AI-powered components
 * Converted from SwiftUI GlowEffect to React
 */

const colors = [
  "#BC82F3",
  "#D8ADFF",
  "#F5B9EA",
  "#C19FFF",
  "#8D9FFF",
  "#9C87F6",
  "#AA6EEE",
  "#CC73B3",
  "#FF6778",
  "#FF8E79",
  "#FFBA71",
  "#DDA080",
  "#C686FF",
  "#BC82F3",
];

const AIGlowEffect = ({ children, width = 3, blur = 8 }) => {
  return (
    <GlowContainer>
      {/* Base glow layer */}
      <GlowLayer width={width} blur={0} animationDelay="0s" />

      {/* Blurred overlay layer for soft glow */}
      <GlowLayer width={width + 4} blur={blur} animationDelay="2s" />

      {/* Extra soft outer glow */}
      <GlowLayer
        width={width + 8}
        blur={blur * 2}
        opacity={0.6}
        animationDelay="2s"
      />

      {/* Content */}
      <ContentWrapper>{children}</ContentWrapper>
    </GlowContainer>
  );
};

// Smooth rotation animation
const rotation = keyframes`
  0% {
    --gradient-angle: 0deg;
  }
  100% {
    --gradient-angle: 360deg;
  }
`;

const GlowContainer = styled.div`
  position: relative;
  border-radius: 25px;
  isolation: isolate;
`;

const GlowLayer = styled.div`
  @property --gradient-angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
  }

  position: absolute;
  inset: -${(props) => props.width}px;
  border-radius: ${(props) => 25 + props.width}px;
  opacity: ${(props) => props.opacity || (props.blur > 0 ? 0.8 : 1)};
  filter: ${(props) => (props.blur > 0 ? `blur(${props.blur}px)` : "none")};
  pointer-events: none;
  z-index: -1;
  background: conic-gradient(from var(--gradient-angle), ${colors.join(", ")});
  animation: ${rotation} 12s linear infinite;
  animation-delay: ${(props) => props.animationDelay || "0s"};
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

export default AIGlowEffect;
